import { useQuery } from "@tanstack/react-query"
import { getProgramRegistration, getProgramRegistrations } from "../api/programs"

export const useProgramRegistrationsQuery = () => {
  return useQuery({
    queryKey: ["programRegistrations"],
    queryFn: () => getProgramRegistrations(),
  })
}

export const useProgramRegistrationQuery = (id) => {
  return useQuery({
    queryKey: ["programRegistration", id],
    queryFn: () => getProgramRegistration(id),
    enabled: !!id, // Only run the query if id is valid
  })
}